const getNestedObject = (nestedObj, pathArr, defaultVar) => {
  return pathArr.reduce(
    (obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : defaultVar),
    nestedObj
  );
};

export default getNestedObject;
